export default __webpack_public_path__ + "static/media/success.7214bdef.gif";